import { createTheme } from '@mui/material/styles'

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  palette: {
    primary: {
      light: '#FC7850',
      main: '#E36139',
      dark: '#C15331',
      contrastText: '#ffffff',
    },
    secondary: {
      light: '#69E4C3',
      main: '#5DBCA2',
      dark: '#5B9082',
      contrastText: '#ffffff',
    },
    error: {
      main: '#E03E3E',
    },
    success: {
      main: '#39C250',
    },
    warning: {
      main: '#FFB800',
      light: 'rgba(255, 184, 0, 0.12)',
    },
    info: {
      main: '#5493F7',
      light: 'rgba(84, 147, 247, 0.08)',
    },
    text: {
      primary: '#121212',
      secondary: '#666666',
      disabled: '#959595',
    },
  },
  shape: {
    borderRadius: 8,
  },
  typography: {
    fontFamily: 'Poppins, sans-serif',
    h3: {
      fontWeight: 600,
      fontSize: 43,
      letterSpacing: 0.5,
      lineHeight: '72px',
    },
    h4: {
      fontWeight: 600,
      fontSize: 34,
      letterSpacing: 0.5,
      lineHeight: '51px',
    },
    h5: {
      fontWeight: 600,
      fontSize: 24,
      letterSpacing: 0.5,
      lineHeight: '36px',
    },
    h6: {
      fontWeight: 600,
      fontSize: 20,
      letterSpacing: 0.5,
      lineHeight: '30px',
    },
    body1: {
      fontWeight: 400,
      fontSize: 16,
      letterSpacing: 0.5,
      lineHeight: '24px',
    },
    body2: {
      fontWeight: 400,
      fontSize: 14,
      letterSpacing: 0.25,
      color: '#666666',
      lineHeight: '20px',
    },
    overline: {
      textTransform: 'uppercase',
      fontWeight: 400,
      fontSize: 12,
      letterSpacing: 2,
      lineHeight: '16px',
    },
    caption: {
      fontWeight: 400,
      fontSize: 12,
      letterSpacing: 0.4,
      color: '#666666',
      lineHeight: '16px',
    },
  },
})

theme.components = {
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: '8px',
        transition: 'all 250ms ease',
        transitionProperty: 'background-color, color',
        textTransform: 'none',
        fontSize: 16,
        fontWeight: 600,
        minWidth: 96,
        height: 56,
        alignContent: 'center',
        textAlign: 'center',
        whiteSpace: 'nowrap',
      },
      contained: {
        background: 'linear-gradient(0.04deg, #E36139 1.26%, #F4771D 100.38%)',
      },
      containedPrimary: {
        boxShadow: '0px 0px 10px rgba(227, 97, 57, 0.24)',
        color: '#ffffff',
        border: `solid 1px transparent`,
        '&:hover': {
          boxShadow: '0px 0px 10px rgba(227, 97, 57, 0.64)',
        },
        '&:disabled': {
          boxShadow: 'none',
          color: theme.palette.text.disabled,
          background: '#D4D4D4',
        },
      },
      outlined: {
        background: 'rgba(252, 120, 80, 0.12)',
      },
      outlinedPrimary: {
        boxShadow: 'none',
        color: theme.palette.primary.main,
        border: `solid 1px ${theme.palette.primary.main}`,
        '&:disabled': {
          background: 'rgba(37, 37, 37, 0.12)',
        },
      },
      text: {
        textTransform: 'none',
        display: 'inline-block',
        padding: 0,
        minHeight: 0,
        minWidth: 0,
        borderRadius: '0px',
        '&:hover': {
          backgroundColor: 'transparent',
        },
        '& .MuiTouchRipple-root span': {
          backgroundColor: 'transparent',
        },
      },
    },
  },
  MuiInputBase: {
    styleOverrides: {
      root: {
        '&:hover': {
          outline: '2px solid #e36139',
        },
        '&:focus-within': {
          outline: '2px solid #e36139',
        },
        '&:focus': {
          outline: '2px solid #e36139',
        },
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        boxShadow: 'none',
        background: 'rgba(255, 253, 251, 0.48)',
        border: '2px solid #FFFFFF',
        boxSizing: 'border-box',
        backdropFilter: 'blur(16px)',
        borderRadius: '16px',
        padding: '24px',
      },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: {
        border: 'none',
      },
    },
  },
  MuiDivider: {
    styleOverrides: {
      root: {
        borderColor: theme.palette.primary.main,
        border: '10px',
        zIndex: 50,
      },
    },
  },
  MuiCheckbox: {
    styleOverrides: {
      root: {
        color: '#C4C4C4',
        padding: '0px 10px',
      },
    },
  },
  MuiLink: {
    styleOverrides: {
      root: {
        textDecoration: 'none',
        cursor: 'pointer',
        '&:hover': {
          textDecoration: 'underline',
        },
      },
    },
  },
}

export { theme }
